import { FileSelectField, FormField } from '@/components/custom/erp';
import { usePhieuXuatTraLaiNhaCungCapContext } from '../../context';
import { FormMode } from '@/types/form';

interface OtherTabProps {
  formMode: FormMode;
}

export default function OtherTab({ formMode }: OtherTabProps) {
  const { transactionOptions } = usePhieuXuatTraLaiNhaCungCapContext();

  return (
    <div className='px-4'>
      <div className='flex flex-col justify-between lg:flex-row'>
        {/* Left column */}
        <div className='w-full space-y-2'>
          <div className='w-full max-w-md'>
            <FormField
              label='Giao dịch'
              name='ma_gd'
              type='select'
              disabled={formMode === 'view'}
              options={transactionOptions}
              defaultValue='TL'
              labelClassName='w-32'
            />
          </div>
        </div>
      </div>
    </div>
  );
}
